import React, { useState, useEffect } from "react";

import CustomModal from "../customModal";
import { formatSecondsToTime } from "../../utilities/helpers";

const SessionExpireModal = ({
  handleStillHere,
  getRemainingTime,
  isPrompted = false,
}) => {
  const [remaining, setRemaining] = useState(() => getRemainingTime() / 1000);

  useEffect(
    () => {
      let intervalId;

      if (isPrompted) {
        intervalId = setInterval(() => {
          const newRemaining = getRemainingTime() / 1000;
          setRemaining(newRemaining);

          if (newRemaining <= 0) {
            clearInterval(intervalId);
          }
        }, 1000);
      }

      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    },
    [isPrompted, getRemainingTime]
  );

  return (
    <CustomModal
      isVisible={isPrompted}
      title="Session Expiring Soon"
      handleDelete={handleStillHere}
      customClass="session-expiry-modal"
      submitButtonText="Stay logged in"
    >
      <p>
        You will be logged out in {formatSecondsToTime(remaining)} for
        inactivity.
      </p>
    </CustomModal>
  );
};

export default SessionExpireModal;
